import { emitSocketV2ResearchAssistantEvent } from '@verantos-dev/app-state-base';
import { ModelVersion } from '@verantos-dev/app-state-research-assistant';
import { transformUser } from '@verantos-dev/core-auth';
import { IVerantosUser } from '@verantos-dev/types-common';

type EmitCohortDSLProps = {
  projectId: string;
  cohortId: string;
  cohortVersionId: string;
  model: ModelVersion;
  fullCohortDsl: string;
  _mapIdToConceptGroupName: (dsl: string) => string;
  user: IVerantosUser;
  callback?: (data?: number) => void;
};
export const emitCohortDSL = ({
  _mapIdToConceptGroupName,
  projectId,
  model,
  cohortId,
  cohortVersionId,
  fullCohortDsl,
  user,
}: EmitCohortDSLProps) => {
  emitSocketV2ResearchAssistantEvent('publish', {
    message: 'uiGeneratedCohort',
    model,
    data: {
      projectId,
      cohortId,
      cohortVersionId,
      uiDSL: _mapIdToConceptGroupName(fullCohortDsl || ''),
      userInfo: transformUser(user),
    },
  });
};
